import clsx from 'clsx'
import { ReactNode } from 'react'

interface Props {
    placeholder: ReactNode
    isFocused?: boolean
    hasValue?: boolean
    hasError?: boolean
    className?: string
}

const InputAnimatedPlaceholder = ({
    placeholder,
    isFocused,
    hasValue,
    hasError,
    className,
}: Props) => {
    const isTransitionedPosition = isFocused || hasValue
    return (
        <div
            className={clsx(
                'absolute left-2 top-2 px-2 py-0 max-w-full z-10 text-left pointer-events-none bg-white',
                'transition-transform duration-[140ms] ease-in-out origin-bottom-left',
                isTransitionedPosition ? 'scale-75 -translate-y-[24px]' : 'right-0.5',
                isTransitionedPosition && hasError ? 'text-[red]' : 'text-[#80868b]',
                className,
            )}>
            {placeholder}
        </div>
    )
}

export default InputAnimatedPlaceholder
